"use strict";

var $body = document.querySelector("body");
var blockCallbackPopupShowing = true;
var $popup;
var autoclosePopupTimer = setTimeout(function () {},0);
var blockSliding = [];
var windowTablet = false;
var windowMobile = false;
var $animElements;
var animPositions = [];

function ready() {
    initCallbackPopup();
    initCallbackButton();
    initSendForm();
    initToTop();
    initSlider();
    checkAnimPositions();

    initWindowScrollEvents();
    initWindowResize();

    var interval = setInterval(function () {
        var $elems = document.querySelectorAll(".animate");

        if ( $elems.length > 0 ) {
            for ( var i = 0; $elems.length > i; i++ ) {
                if ( $elems[i].getAttribute("data-anim") === "anim" ) {
                    $elems[i].setAttribute("data-anim", "remove");
                } else if ( $elems[i].getAttribute("data-anim") === "remove" ) {
                    removeAnimations($elems[i]);
                }
            }
        } else {
            clearInterval(interval);
        }
    }, 3000);
}

function initCallbackPopup() {
    $popup = document.querySelectorAll(".js-callback-popup")[0];

    var $closeButtons = $popup.querySelectorAll(".js-callback-popup_close");

    for ( var closeButtonsIndex = 0; $closeButtons.length > closeButtonsIndex; closeButtonsIndex++ ) {
        var $closeButton = $closeButtons[closeButtonsIndex];

        (function ($closeButton, closeButtonsIndex) {
            $closeButton.addEventListener("click", function () {
                closeCallbackPopup();
            });
        })($closeButton, closeButtonsIndex);
    }

    blockCallbackPopupShowing = false;
}

function closeCallbackPopup() {
    blockCallbackPopupShowing = true;

    $popup.classList.add("b-popup_hidding");

    // $body.style.overflowY = "auto";
    $body.classList.remove("no-scroll");

    setTimeout(function () {
        $popup.classList.remove("b-popup_show");// ie 11 not support multiple add/removing
        $popup.classList.remove("b-popup_hidding");
        $popup.style.display = "none";

        blockCallbackPopupShowing = false;
    }, 200);
}

function openCallbackPopup(openFormSended, tarif) {
    var $innerForm = $popup.querySelectorAll(".b-popup__inner_form")[0];
    var $innerFormSended = $popup.querySelectorAll(".b-popup__inner_form-sended")[0];
    var popupHeight = 0;
    var innerHeight = 0;

    clearTimeout(autoclosePopupTimer);

    if ( !openFormSended ) {
        $innerForm.style.display = "block";
        $innerFormSended.style.display = "none";

        $popup.querySelectorAll("input[data-hidden='tarif']")[0].value = (tarif ? tarif : "");
    } else {
        blockCallbackPopupShowing = true;

        $innerForm.style.display = "none";
        $innerFormSended.style.display = "block";

        autoclosePopupTimer = setTimeout(function () {
            closeCallbackPopup();
        }, 5000);
    }

    $popup.style.paddingTop = 0;
    $popup.style.display = "block";

    popupHeight = $popup.offsetHeight;

    if ( !openFormSended ) {
        innerHeight = $innerForm.offsetHeight;
    } else {
        innerHeight = $innerFormSended.offsetHeight;
    }

    if ( popupHeight >= innerHeight ) {
        $popup.style.paddingTop = (popupHeight - innerHeight) / 2 +"px";
    }

    setTimeout(function () {
        // $body.style.overflowY = "hidden";
        $body.classList.add("no-scroll");

       $popup.classList.add("b-popup_show");
    },0);
}

function initCallbackButton() {
    var $buttons = document.querySelectorAll(".js-btn-order");

    for ( var buttonIndex = 0; $buttons.length > buttonIndex; buttonIndex++ ) {
        var $button = $buttons[buttonIndex];

        (function ($button, buttonIndex) {
            $button.addEventListener("click", function (event) {
                if ( !blockCallbackPopupShowing ) {
                    var tarif = $button.getAttribute("data-tarif");

                    openCallbackPopup(false, tarif);
                }
            });
        })($button, buttonIndex);
    }
}

function initSendForm() {
    var $forms = document.querySelectorAll(".js-form");

    for ( var formIndex = 0; $forms.length > formIndex; formIndex++ ) {
        var $form = $forms[formIndex];

        (function ($form, formIndex) {
            var action = $form.getAttribute("action");
            var $name = $form.querySelectorAll("input[name='name']")[0];
            var $phone = $form.querySelectorAll("input[name='phone']")[0];
            var $tarif = $form.querySelectorAll("input[name='tarif']")[0];

            $form.addEventListener("submit", function (event) {
                event.preventDefault();

                var nameValue = $name.value.trim();
                var phoneValue = $phone.value.trim();
                var tarifValue = $tarif.value.trim();

                if ( !nameValue ) {
                    $name.classList.add("field-error");
                } else {
                    $name.classList.remove("field-error");
                }

                if ( !phoneValue ) {
                    $phone.classList.add("field-error");
                } else {
                    $phone.classList.remove("field-error");
                }

                if ( nameValue > "" && phoneValue > "" ) {
                    // TODO: send

                    openCallbackPopup(true);

                    $name.value = "";
                    $phone.value = "";
                    $tarif.value = "";
                }

                return false;
            });
        })($form, formIndex);
    }
}

function initToTop() {
    var $toTop = document.querySelectorAll(".js-to-top")[0];

    $toTop.addEventListener("click", function () {
        window.scrollTo(0,0);
    });
}

// Slider
function initSlider() {
    var $sliders = document.querySelectorAll(".js-slider");

    if ( $sliders.length < 1 ) {
        return false;
    }

    for ( var sliderIndex = 0; $sliders.length > sliderIndex; sliderIndex++ ) {
        var $slider = $sliders[sliderIndex];

        (function ($slider, sliderIndex) {
            blockSliding[sliderIndex] = true;
            var sliderHovered = false;
            var $items = $slider.querySelectorAll(".b-slider__item");

            if ( $items.length < 2 ) {
                return false;
            }

            var $itemActive = $slider.querySelectorAll(".b-slider__item_active");

            if ( $itemActive.length !== 1 ) {
                $items.classList.remove("b-slider__item_active");
                $items[0].classList.add("b-slider__item_active");
                $itemActive = $items[0];
            } else {
                $itemActive = $itemActive[0];
            }

            var activeIndex = sliderGetActiveIndex($items);

            var $dots = sliderCreateDots($slider, $items.length, activeIndex);

            for ( var dotIndex = 0; $dots.length > dotIndex; dotIndex++ ) {
                var $dot = $dots[dotIndex];

                (function ($dot, dotIndex) {
                    $dot.addEventListener("mouseenter", function () {
                        sliderHovered = false;

                        clearInterval(settedInterval);
                        settedInterval = setInterval(function () {
                            var nextIndex = (activeIndex + 1 < $items.length ? activeIndex + 1 : 0);

                            $dots[nextIndex].click();
                        }, 5000);
                    });

                    $dot.addEventListener("click", function () {
                        if ( blockSliding[sliderIndex] || activeIndex === dotIndex || sliderHovered ) {
                            return false;
                        }

                        activeIndex = sliderMove($itemActive, $items, $dots, activeIndex, sliderIndex, dotIndex);

                        $itemActive = $items[activeIndex];
                    });
                })($dot, dotIndex);
            }

            var settedInterval = setInterval(function () {
                var nextIndex = (activeIndex + 1 < $items.length ? activeIndex + 1 : 0);

                $dots[nextIndex].click();
            }, 5000);

            // events
            $slider.addEventListener("mouseenter", function () {
                sliderHovered = true;

                clearInterval(settedInterval);
            });

            $slider.addEventListener("mousemove", function (event) {
                if ( !event.target.classList.contains("b-slider__dot-item") ) {
                    sliderHovered = true;

                    clearInterval(settedInterval);
                }
            });

            $slider.addEventListener("mouseleave", function () {
                sliderHovered = false;

                clearInterval(settedInterval);
                settedInterval = setInterval(function () {
                    var nextIndex = (activeIndex + 1 < $items.length ? activeIndex + 1 : 0);

                    $dots[nextIndex].click();
                }, 5000);
            });

            blockSliding[sliderIndex] = false;
        })($slider, sliderIndex);
    }
}

function sliderGetActiveIndex($items) {
    var active = -1;

    for ( var i = 0; $items.length > i; i++ ) {
        if ( $items[i].classList.contains("b-slider__item_active") ) {
            active = i;

            break;
        }
    }

    return active;
}

function sliderCreateDots($slider, length, activeIndex) {
    var html = '<div class="b-slider__dots">';

    for ( var i = 0; length > i; i++ ) {
        html+= '<div class="b-slider__dot-item'+ (i === activeIndex ? " b-slider__dot-item_active" : "") +'"></div>';
    }

    html+= '</div>';

    $slider.insertAdjacentHTML("beforeend", html);

    var $dotsWrapper = $slider.querySelector(".b-slider__dots");

    $dotsWrapper.style.marginLeft = -($dotsWrapper.offsetWidth / 2) +"px";

    return $slider.querySelectorAll(".b-slider__dot-item");
}

function sliderMove($itemActive, $items, $dots, activeIndex, sliderIndex, nextIndex) {
    blockSliding[sliderIndex] = true;

    if ( typeof(nextIndex) !== "number" ) {
        nextIndex = (activeIndex + 1 < $items.length ? activeIndex + 1 : 0);
    }

    $itemActive.classList.add("b-slider__item_move_active");
    $items[nextIndex].classList.add("b-slider__item_active");

    $dots[activeIndex].classList.remove("b-slider__dot-item_active");
    $dots[nextIndex].classList.add("b-slider__dot-item_active");

    setTimeout(function () {
        $itemActive.classList.remove("b-slider__item_active");
        $itemActive.classList.remove("b-slider__item_move_active");

        if ( blockSliding[sliderIndex] && blockSliding[sliderIndex] !== "important" ) {
            blockSliding[sliderIndex] = false;
        }
    }, 1000);

    return nextIndex;
}
// // end Slider

function checkAnimPositions() {
    if ( !Modernizr.touchevents && Modernizr.cssanimations ) {
        $animElements = document.querySelectorAll(".animate[data-anim]");

        for ( var i = 0; $animElements.length > i; i++ ) {
            animPositions[i] = getPosition($animElements[i]);
            $animElements[i].style.opacity = 0;
        }
    }
}

function initWindowScrollEvents() {
    var $toTop = document.querySelectorAll(".js-to-top")[0];
    var toTopShowed = false;
    var lastScrollY = 0;

    var timeout = setTimeout(function () {},0);

    window.addEventListener("scroll", function (event) {
        if ( $body.classList.contains("no-scroll") ) {
            window.scrollTo(0,lastScrollY);

            return false;
        }

        lastScrollY = window.pageYOffset;

        if ( window.pageYOffset >= 1000 && !toTopShowed ) {
            $toTop.classList.add("showed");
            toTopShowed = true;
        } else if ( window.pageYOffset < 1000 && toTopShowed ) {
            $toTop.classList.remove("showed");
            toTopShowed = false;
        }

        if ( (window.pageYOffset + window.innerHeight) >= ($body.scrollHeight - 60) ) {
            $toTop.style.marginBottom = (window.pageYOffset + window.innerHeight - $body.scrollHeight + 60) +"px";
        } else {
            $toTop.style.marginBottom = 0;
        }

        if ( !Modernizr.touchevents && Modernizr.cssanimations ) {

            clearTimeout(timeout);

            timeout = setTimeout(function () {
                var start = window.pageYOffset + window.innerHeight - (window.innerHeight  / 10);

                for ( var i = 0; $animElements.length > i; i++ ) {
                    if ( start >= animPositions[i] ) {
                        var anim = $animElements[i].getAttribute("data-anim");

                        $animElements[i].setAttribute("data-anim", "anim");

                        if ( anim !== "anim" && anim !== "remove" ) {
                            $animElements[i].classList.add(anim);
                            $animElements[i].style.opacity = 1;
                        }
                    }
                }
            },20);
        }
    });

//Modernizr.touchevents
    //Modernizr.cssanimations
}

function initWindowResize() {
    var timeout = setTimeout(function () {},0);

    window.addEventListener("resize", function (event) {
        // $$.window.width = $$.$window.width();
        // $$.window.height = $$.$window.height();

        // $$.window.desctopLg = window.matchMedia('(max-width:1259px)').matches;
        // $$.window.desctop = window.matchMedia('(max-width:1023px)').matches;
        windowTablet = window.matchMedia('(max-width:767px)').matches;
        windowMobile = window.matchMedia('(max-width:479px)').matches;

        clearTimeout(timeout);

        timeout = setTimeout(function () {
            if ( !Modernizr.touchevents && Modernizr.cssanimations ) {
                $animElements = document.querySelectorAll(".animate[data-anim]");

                for ( var i = 0; $animElements.length > i; i++ ) {
                    animPositions[i] = getPosition($animElements[i]);
                }
            }
        },100);
    });
}

function removeAnimations(from) {
    from.classList.remove("animate");
    from.classList.remove("animate_from-big");
    from.classList.remove("animate_from-small");
    from.classList.remove("animate_from-left");
    from.classList.remove("animate_from-bot");
    from.classList.remove("animate_from-right");
    from.classList.remove("animate_rotate-25");
    from.classList.remove("animate_text-highlight");
    from.classList.remove("animate_border-bot");
    from.classList.remove("animate_bg-main-row");
    from.classList.remove("animate_bg-logo-main");

    from.removeAttribute("data-anim");
}

/////////////////
function getPosition($elem) {
    var $html = document.querySelectorAll("html");
    var $body = document.querySelectorAll("body");
    var top = 0;
    var i = 0;

    while ( true ) {
        if ( $elem !== $body[0] && $elem !== $html[0] && $elem > "" ) {
            top+= $elem.offsetTop;
            $elem = $elem.offsetParent;
        } else {
            return top;
        }

        if ( i++ > 100 ) {
            return false;
        }
    }
}

////////
document.addEventListener("DOMContentLoaded", ready);